module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["wrapper"]
  }, [(_vm.show) ? _c('div', {
    ref: "dof-cover",
    staticClass: ["g-cover"],
    style: _vm.coverStyle,
    on: {
      "click": _vm.clickCover
    }
  }) : _vm._e(), (_vm.show && _vm.buttons.length) ? _c('div', {
    ref: "dof-popover",
    staticClass: ["g-popover"],
    style: _vm.contentStyle
  }, [_c('div', {
    class: ['u-popover-arrow', _vm.theme !== 'white' && 'u-popover-theme-dark'],
    style: _vm.arrowStyle
  }), _c('scroller', {
    ref: "dof-inner-popover",
    class: ['u-popover-inner', _vm.theme !== 'white' && 'u-popover-theme-dark'],
    style: _vm.popoverInnerStyle,
    attrs: {
      "showScrollbar": "false"
    }
  }, _vm._l((_vm.buttons), function(item, i) {
    return _c('div', {
      key: i,
      class: [
        'i-btn',
        i === _vm.buttons.length - 1 ? 'i-btn-noborder' : '',
        _vm.layoutDirection == 'row' ? 'row-layout' : 'column-layout',
        _vm.layoutDirection == 'row' && i != _vm.buttons.length - 1 ? 'borderRight' : '',
        _vm.layoutDirection == 'column' && i != _vm.buttons.length - 1 ? 'borderBottom' : ''
      ],
      on: {
        "click": function($event) {
          _vm.dofButtonClicked(i, item.key)
        }
      }
    }, [(item.icon && !_vm._isColmo) ? _c('image', {
      staticClass: ["btn-icon"],
      attrs: {
        "src": item.icon
      }
    }) : _vm._e(), (item.icon && _vm._isColmo) ? _c('dof-iconfont', {
      attrs: {
        "code": item.icon,
        "size": 56,
        "color": _vm.textStyle.color ? _vm.textStyle.color : 'rgba(255,255,255,0.80)'
      },
      on: {
        "dofIconFontClicked": function($event) {
          _vm.dofButtonClicked(i, item.key)
        }
      }
    }) : _vm._e(), _c('text', {
      class: ['btn-text', _vm.theme !== 'white' && 'btn-text-theme-dark'],
      style: _vm.textStyle
    }, [_vm._v(_vm._s(item.text))])], 1)
  }))]) : _vm._e(), (_vm.show && !_vm.buttons.length) ? _c('div', {
    ref: "dof-popover",
    staticClass: ["g-popover"],
    style: _vm.contentStyle,
    on: {
      "click": function () {}
    }
  }, [_c('div', {
    class: ['u-popover-arrow', _vm.theme !== 'white' && 'u-popover-theme-dark'],
    style: _vm.arrowStyle
  }), _c('div', {
    ref: "dof-inner-popover",
    staticClass: ["content-inner"],
    style: _vm.innerContentStyle
  }, [_vm._t("default", [_c('text', {
    staticClass: ["textContent"],
    style: _vm.textStyle
  }, [_vm._v(_vm._s(_vm.textContent))]), _vm._t("icon", [(_vm.isShowClose) ? _c('div', {
    staticClass: ["closeBox"],
    on: {
      "click": function($event) {
        _vm.$emit('clickedCloseBtn')
      }
    }
  }, [(!_vm._isColmo) ? _c('image', {
    staticClass: ["closeIcon"],
    attrs: {
      "src": _vm._isDiablo ? _vm.imgs.closeDiablo : _vm.imgs.close
    }
  }) : _c('dof-iconfont', {
    attrs: {
      "code": '\u4725',
      "size": 32,
      "color": _vm._isColmo ? 'rgba(255,255,255,0.80)' : '#1E2E37'
    },
    on: {
      "dofIconFontClicked": function($event) {
        _vm.$emit('clickedCloseBtn')
      }
    }
  })], 1) : _vm._e()])])], 2)]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-4e9a4386!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-popover2/index.vue
// module id = 611
// module chunks = 0 1